// frontend/src/livequiz/LiveQuizStudentEntry.js
import React, { useState } from 'react';
import './livequiz.css';
import API_BASE_URL from '../quiz_management/config';
import LiveQuizStudentPoll from './LiveQuizStudentPoll';
import LiveQuizStudentBuzzer from './LiveQuizStudentBuzzer';
import LiveQuizStudentTurnBased from './LiveQuizStudentTurnBased';
import { useNavigate } from 'react-router-dom';

const getStudentId = () => {
    try {
        return JSON.parse(localStorage.getItem('student') || '{}').student_id ?? null;
    } catch {
        return null;
    }
};

const LiveQuizStudentEntry = () => {
    const navigate = useNavigate();
    const [sessionCode, setSessionCode] = useState('');
    const [mode, setMode] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const studentId = getStudentId();

    const checkSession = async () => {
        if (!studentId) {
            setError('Your session has expired. Please log out and log in again.');
            return;
        }
        if (!sessionCode.trim()) {
            setError('Please enter a session code');
            return;
        }
        setError(null);
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/livequiz/session/${sessionCode.toUpperCase()}`);
            const data = await res.json();
            if (!res.ok) {
                setError(typeof data.detail === 'string' ? data.detail : 'Session not found');
                setLoading(false);
                return;
            }
            setMode(data.mode);
        } catch (err) {
            setError('Failed to check session');
        } finally {
            setLoading(false);
        }
    };

    if (mode === 'poll') return <LiveQuizStudentPoll studentId={studentId} initialSessionCode={sessionCode.toUpperCase()} />;
    if (mode === 'buzzer') return <LiveQuizStudentBuzzer studentId={studentId} initialSessionCode={sessionCode.toUpperCase()} />;
    if (mode === 'turn_based') return <LiveQuizStudentTurnBased studentId={studentId} initialSessionCode={sessionCode.toUpperCase()} />;

    return (
        <div className="livequiz-container">
            <h2 className="livequiz-title">Live Quiz</h2>

            {error && <div className="livequiz-error">{error}</div>}

            <div className="livequiz-setup-card">
                <button className="livequiz-secondary-btn" style={{ marginBottom: '12px' }}
                    onClick={() => navigate('/dashboard')}>
                    ← Back to Dashboard
                </button>
                <label className="livequiz-label">Session Code</label>
                <input
                    type="text"
                    className="livequiz-input livequiz-code-input"
                    value={sessionCode}
                    onChange={(e) => setSessionCode(e.target.value.toUpperCase())}
                    placeholder="e.g. AB12CD"
                    maxLength={10}
                />
                <button className="livequiz-primary-btn" onClick={checkSession} disabled={loading}>
                    {loading ? 'Checking...' : 'Continue'}
                </button>
            </div>
        </div>
    );
};

export default LiveQuizStudentEntry;